module.exports = __webpack_public_path__ + "img/POP-00016-3.9999c296.jpg";